export default function(pagePath) {
  const BASE_URL = 'https://mts-link.ru'
  const canonicalMap = {
    '/user/organizer-new/': '/user/organizer/'
  }

  if (canonicalMap[pagePath]) {
    return BASE_URL + canonicalMap[pagePath]
  }

  return BASE_URL + pagePath
}
